var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderDeliverySlip',{attrs:{"img_header":_vm.header_image,"header":"รายละเอียดใบส่งของ (delivery Slip information)","link_back":"salemain/saledeliveryslipwholesale"}}),_c('Detail_deliveryslip_wholesale')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }